export const decisioningStudioAgentsAppGroupIdDsaIdDetails =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/details";
